import type { LocalTestInstructionModel } from '../models/ultrasonic.models';

// TODO: Replace with real API data
export const DEFAULT_TEST_INSTRUCTIONS: LocalTestInstructionModel[] = [
  {
    id: '43065671436845772',
    name: 'S 231202-5',
    equipmentId: '4222124650711198',
    equipmentName: 'SWE ScanMaster LS200',
  },
  {
    id: '43065671436846158',
    name: 'SWE LS200 - S 231202-5 (3 Volumes)',
    equipmentId: '4222124650711198',
    equipmentName: 'SWE ScanMaster LS200',
  },
  {
    id: '43065671436846488',
    name: 'SWE LS200 - S 231202-5 (2 Volumes)',
    equipmentId: '4222124650711198',
    equipmentName: 'SWE ScanMaster LS200',
  },
  {
    id: '43065671436847056',
    name: 'ISB LS200 - S 231202-5 (2 Volumes)',
    equipmentId: '4222124650737151',
    equipmentName: 'ISB Scanmaster LS200',
  },
  {
    id: '43065671436847295',
    name: 'ISB LS200 - S 231202-5 (3 Volumes)',
    equipmentId: '4222124650737151',
    equipmentName: 'ISB Scanmaster LS200',
  },
  {
    id: '43065671436847522',
    name: 'ISB DS200-XL - S 231202-5 (2 Volumes)',
    equipmentId: '4222124650737751',
    equipmentName: 'ISB Scanmaster DS200-XL',
  },
  {
    id: '43065671436847856',
    name: 'ISB DS200-XL - S 231202-5 (3 Volumes)',
    equipmentId: '4222124650737751',
    equipmentName: 'ISB Scanmaster DS200-XL',
  },
  {
    id: '43065671436848109',
    name: 'ISB LS500 - S 231202-5 (2 Volumes)',
    equipmentId: '4222124650737289',
    equipmentName: 'ISB Scanmaster LS 500',
  },
  {
    id: '43065671436848326',
    name: 'ISB LS500 - S 231202-5 (3 Volumes)',
    equipmentId: '4222124650737289',
    equipmentName: 'ISB Scanmaster LS 500',
  },
  { id: '43065671436871404', name: 'IN ISB 20192-D' },
  { id: '43065671436871486', name: 'IN ISB 20192-G' },
  { id: '43065671436871671', name: 'SWE LS200 - S 231202-5 (2 Volumes) - V2' },
  { id: '43065671436871695', name: 'IN ISB 20456-C' },
  { id: '43065671436871813', name: 'NaN' },
];
